module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<table class="DescartesTable table table-striped table-bordered table-hover" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n    <thead>\n        <tr>\n            <th>\n                <label class="checkbox-inline">\n                    <input id="selectAll" type="checkbox" value="true">&nbsp;\n                </label>\n            </th>\n            ';
 _.forEach(columns,function(column){ ;
__p += '\n            <th><span class="DescartesUIText">' +
((__t = (column.title)) == null ? '' : __t) +
'</span></th>\n                ';
 }); ;
__p += '\n        </tr>\n    </thead>\n    <tbody id="' +
((__t = (id)) == null ? '' : __t) +
'_body">\n        ';
 _.forEach(data,function(layer,index){
            var readableMinScale = '-';
            if(layer.minScale !== 0) {
                readableMinScale = Descartes.Utils.readableScale(layer.minScale);
            }
            var readableMaxScale = '-';
            if(layer.maxScale !== 0) {
                readableMaxScale = Descartes.Utils.readableScale(layer.maxScale);
            }
        ;
__p += '\n        <tr>\n            <td>\n                <label class="checkbox-inline">\n                    <input type="hidden" name="selected_' +
((__t = (index)) == null ? '' : __t) +
'" value="false"/>\n                    <input type="checkbox" name="selected_' +
((__t = (index)) == null ? '' : __t) +
'" value="true">&nbsp;\n                </label>\n            </td>\n            <td><span class="DescartesUIText">' +
((__t = (layer.title)) == null ? '' : __t) +
'</span></td>\n            <td>\n                <select class="DescartesUISelect form-control" name="format_' +
((__t = (index)) == null ? '' : __t) +
'">\n                    ';
 _.forEach(layer.formats,function(format){ ;
__p += '\n                    <option>' +
((__t = (format)) == null ? '' : __t) +
'</option>\n                    ';
 }); ;
__p += '\n                </select>\n            </td>\n            <td><span class="DescartesUIText">' +
((__t = (readableMinScale)) == null ? '' : __t) +
'</span></td>\n            <td><span class="DescartesUIText">' +
((__t = (readableMaxScale)) == null ? '' : __t) +
'</span></td>\n            <td><span class="DescartesUIText">' +
((__t = (layer.description)) == null ? '' : __t) +
'</span></td>\n            <td>\n                ';
if(layer.styles.length>0) {;
__p += '\n                <select class="DescartesUISelect form-control" name="style_' +
((__t = (index)) == null ? '' : __t) +
'">\n                    ';
 _.forEach(layer.styles,function(style){ ;
__p += '\n                    <option value="' +
((__t = (style.Name)) == null ? '' : __t) +
'">' +
((__t = (style.Title)) == null ? '' : __t) +
'</option>\n                    ';
 }); ;
__p += '\n                </select>\n                ';
};
__p += '\n            </td>\n            <td><span class="DescartesUIText">' +
((__t = (layer.keywordList)) == null ? '' : __t) +
'</span></td>\n            ';
 if (layer.metadataURL !== '-') { ;
__p += '\n            		<td><a href="' +
((__t = (layer.metadataURL)) == null ? '' : __t) +
'" target="_blank"><span class="DescartesUIText">Lien</span></a></td>\n            ';
 } else { ;
__p += '\n           			<td><span class="DescartesUIText">' +
((__t = (layer.metadataURL)) == null ? '' : __t) +
'</span></td>\n            ';
 };
__p += '\n        </tr>\n        ';
 }); ;
__p += '\n    </tbody>\n</table>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/ChooseWmsLayersGrid.ejs
// module id = 409
// module chunks = 0